import { useTranslation } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import { getValidBlockNumber } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/helpers'
import { literalTranslationOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/TrackingPagePreview/constants'

const BlockSettingNumberField = ({ field, value, onChange }) => {
  const { t } = useTranslation()

  const handleChange = event => {
    const typedValue = event.target.value

    onChange(field.key, typedValue === '' ? typedValue : Number(typedValue))
  }

  const handleBlur = () => onChange(field.key, getValidBlockNumber(value, field))

  return (
    <InputWithLabel
      fullWidth
      type="number"
      role="spinbutton"
      label={t(field.label, literalTranslationOptions)}
      helperText={t(field.helper, literalTranslationOptions)}
      value={String(value)}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}

export default BlockSettingNumberField
